import React, { useState } from "react";
import axios from "axios";
import logo from "../../assets/Picture1.png"
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { loginMethod } from "../../hook/auth";
import { toast,ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";

function SignupForm() {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    phone: "",
    username: "",
    password: "",
    password_confirmation: "",
    identity_number:"102"
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showcheckPassword, setShowcheckPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const dispatch = useDispatch()
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };
  const handleChange = (e) => {
  const { name, value } = e.target;

  // تحديث كلمة المرور
  if (name === "password") {
    setFormData({
      ...formData,
      password: value,
      password_confirmation: value   // ← نسخ القيمة
    });
  } else {
    setFormData({
      ...formData,
      [name]: value
    });
  }
};


  const validate = () => {
    const newErrors = {};
    // if (!formData.phone.match(/^\d{10,15}$/)) {
    //   newErrors.phone = "Phone must be 10-15 digits";
    // }
    if (!formData.username) {
      newErrors.username = "Username is required";
    }
    // if (!formData.identity_number) {
    //   newErrors.identity_number = "ID is required";
    // }
    if (!formData.password_confirmation) {
      newErrors.password_confirmation = "مطوب تأكيد كلمة المرور ";

    }
    if (!formData.password) {
      newErrors.password = "مطوب  كلمة المرور";
    }
    if (formData.password_confirmation !== formData.password) {
      newErrors.password_confirmation = " كلمة  المرور غير متطابقة";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true)
    try {
      const response = await axios.post(" https://nanosoft.technology/academy_new/api/user/auth/register", formData);
      // setMessage("Signup successful!");
      console.log(response.data);
      setLoading(false)

      dispatch(loginMethod({
        data: response.data.data.user,
        access_token: response.data.data.access_token
      }))
      navigate("/dashboard/Dashboard")
    } catch (error) {
      setLoading(false)
  const message =
    error.response?.data?.message ||
    Object.values(error.response?.data?.errors || {})[0]?.[0] ||
    "حدث خطأ، حاول مرة أخرى";

  toast.error(message, {
    position: "bottom-right",
    autoClose: 3000
  });
}

  };
  return (
    <section className='h-100  d-flex justify-content-center mt-5 login_form'>
      <ToastContainer />

      <div>
        <div>
          <img src={logo} alt='' />
        </div>
        <div>
          <h4 className='text-center'>مرحباً </h4>
          <p className='text-muted text-center'>سجل معانا </p>
        </div>
        <form className='mt-4'>
          {message && { message }}
          <div className="form-group">
            <label className="mb-1 text-right w-100" style={{ color: "#7e7e7e" }}><strong>الاسم</strong></label>
            <input className="form-control"
              type="text" name="username" value={formData.username} onChange={handleChange}
            />
            {errors.username && <p style={{ color: "red" }}>{errors.username}</p>}
          </div>
          <div className="form-group">

            <label className="mb-1 text-right w-100" style={{ color: "#7e7e7e" }}><strong>رقم الهاتف</strong></label>
            <input className="form-control"
              type="number" name="phone" value={formData.phone} onChange={handleChange}
            />
            {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}

          </div>
          {/*
          <div className="form-group position-relative">
            <label className="mb-1  text-right w-100" style={{ color: "#7e7e7e" }}><strong>رقم الهوية</strong></label>
            <input
              id="dz-password" className="form-control"
              type="text" name="identity_number" value={formData.identity_number} onChange={handleChange}
            />
            {errors.identity_number && <p style={{ color: "red" }}>{errors.identity_number}</p>}
          </div>
           */}     
          <div className="form-group position-relative">
            <label className="mb-1  text-right w-100" style={{ color: "#7e7e7e" }}><strong>كلمة المرور</strong></label>
            <input
              id="dz-password" className="form-control"
              type={showPassword ? "text" : "password"} name="password" value={formData.password} onChange={handleChange}
            />
            {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
            <div
              style={{ position: "absolute", left: 10, bottom: 8 }}
              onClick={() => setShowPassword(!showPassword)}>
              {showPassword ?
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
                  <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                  <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                  <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                </svg>
                :
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                </svg>

              }
            </div>

          </div>
  {/**
     <div className="form-group position-relative">
            <label className="mb-1  text-right w-100" style={{ color: "#7e7e7e" }}><strong>تأكيد كلمة المرور</strong></label>
            <input id="dz-password" className="form-control" type={showcheckPassword ? "text" : "password"} name="password_confirmation" value={formData.password_confirmation} onChange={handleChange} />
            {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation}</p>}

            <div onClick={() => setShowcheckPassword(!showcheckPassword)}
              style={{ position: "absolute", left: 10, bottom: 8 }}

            >
              {
                showcheckPassword ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                    <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                  </svg>
                  :
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                  </svg>
              }
            </div>
          </div>
           */}     
          <div className="text-center">

            {/* <div type="submit" className="btn btn-block text-white"onClick={handleSubmit}>تسجيل </div> */}

            {
              loading ?

                <div className=" bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center" onClick={handleSubmit}>
                  <p className='mb-0 mx-1'>
                    تسجيل
                  </p>
                  <Spinner size='l' />

                </div>

                :

                <div className=" btn-block py-2 rounded text-white" onClick={handleSubmit}style={{cursor:"pointer"}}>تسجيل </div>

            }
          </div>
          <div className="text-center">

            <Link to='/'>
              <div type="submit" className="text-muted text-underline mt-4" style={{
                textDecoration: "underline",
                fontWeight: "600"
              }}>
                أمتلك حساب              </div>

            </Link>
          </div>
        </form>
      </div>

    </section>)
}

export default SignupForm